import { polyurethaneAccionesRoles } from '../../acciones-roles/departamentos/polyurethane-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const PolyurethaneRoutes: SideBarButton = {
  data: {
    name: 'Polyurethane',
    appendUrl: './polyurethane',
    roles: polyurethaneAccionesRoles.sideNavActions.root, // nuevo permiso creado
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Produccion',
        url: '/scheduler',
        otherUniqueUrls: ['/scheduler/trimming'],
        roles: polyurethaneAccionesRoles.sharedActions.scheduler,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Calidad',
        url: '/quality-control/visual',
        otherUniqueUrls: [
          '/quality-control/trimming',
          '/quality-control/lines',
        ],
        roles: polyurethaneAccionesRoles.sharedActions.qualityControl,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Rechazado QC',
        url: '/visual-rejected',
        roles: polyurethaneAccionesRoles.sharedActions.rejectedVisualQC,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: polyurethaneAccionesRoles.sharedActions.validation,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Etiquetas',
        url: '/packing-box',
        roles: polyurethaneAccionesRoles.sharedActions.packingBox,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Agregar Datos QC',
        url: '/qc-data',
        roles: polyurethaneAccionesRoles.sharedActions.qcData,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/polyurethane',
        roles: polyurethaneAccionesRoles.sideNavActions.reportsPbiPolyurethane,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Alertas de Calidad',
        url: '/quality-alerts-admin',
        roles: polyurethaneAccionesRoles.sharedActions.qualityAlertsAdmin,
      },
      options: PreConfigButton3,
    },
  ],
};
